module.exports = __webpack_public_path__ + "img/hero-crew.663ad557.png";